import { render, staticRenderFns } from "./move-from-old.vue?vue&type=template&id=07641f0f&"
import script from "./move-from-old.vue?vue&type=script&lang=js&"
export * from "./move-from-old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports